// extracted by mini-css-extract-plugin
module.exports = {"plus":"_5D1JF8q4"};